import { useEffect, useState } from "react";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputsYorN from "../ProfilesComp/InputsYorN";
import InputBasic from "../ProfilesComp/InputsBasic";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSectionMentalHealth } from "../../../store/Profiles/profilesSlice";

const StepMentalHealthCuestTwo = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const storedData = useSelector(state => state.profiles.MentalHealth);

    const [formData, setFormData] = useState({
        grooming: "",
        oriented: "",
        motorCoordination: "",
        thoughtContent: "",
        thoughtContentDetails: "",
        memory: "",
        memoryDetails: "",
        judgment: "",
        insight: "",
        underInfluence: "",
        hasMentalHealthIssues: "",
        mentalHealthIssuesDetails: "",
        significantMentalHealthEvent: "",
        significantMentalHealthEventExplain: "",
        lifeChanges: "",
        lifeChangesDetails: "",
        wantsHelp: "",
        interestedInTherapy: "",
        pastTherapy: "",
        pastTherapyDetails: "",
        pastDiagnosis: "",
        currentTreatment: "",
        currentTreatmentDetails: "",
        currentDiagnosis: "",
        Haveyoueverbeen: "",
        HaveyoueverbeenDetails: "",
        hospital:[{ Date: "", WhereHospitalized: "", Reason: "", Duration: ""}],
        Areyoutakingmedications:""
        
    });

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            ...storedData
        }));
    }, [storedData]);

    const handleHouseholdChange = (index, field, value) => {
        const updatedMembers = [...formData.hospital];
        updatedMembers[index][field] = value;
        setFormData((prevData) => ({
            ...prevData,
            hospital: updatedMembers,
        }));
    };

    const addHouseholdMember = () => {
        setFormData((prevData) => ({
            ...prevData,
            hospital: [...prevData.hospital, {Date: "",WhereHospitalized: "",Reason: "",Duration: ""}],
        }));
    };

    const removeHouseholdMember = () => {
        setFormData((prevData) => ({
            ...prevData,
            hospital: prevData.hospital.slice(0, -1),
        }));
    };

    const handleChange = async(key, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [key]: value
        }));
    };

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSectionMentalHealth({ section: "MentalHealth", data: { MentalHealth:formData } }));
    }

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.MentalHealth.MentalHealth")}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Wouldyouliketo")} 
                    value={formData.wantsHelp} onChange={(value) => handleChange("wantsHelp", value)} />    
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Areyouinterested")} 
                    value={formData.interestedInTherapy} onChange={(value) => handleChange("interestedInTherapy", value)} />   
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Haveyouever")} 
                    value={formData.pastTherapy} onChange={(value) => handleChange("pastTherapy", value)} />
                {formData.pastTherapy === "yes" && (
                    <>
                        <InputBasic Translation="Profiles.MentalHealth.Ifyes,name" 
                            value={formData.pastTherapyDetails} onChange={(e) => handleChange("pastTherapyDetails", e.target.value)} />
                        <InputBasic Translation="Profiles.MentalHealth.Diagnosis" 
                        value={formData.pastDiagnosis} onChange={(e) => handleChange("pastDiagnosis", e.target.value)} />
                    </>
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Areyoucurrently")}
                    value={formData.currentTreatment} onChange={(value) => handleChange("currentTreatment", value)} />
                {formData.currentTreatment === "yes" && (
                    <>
                        <InputBasic Translation="Profiles.MentalHealth.Ifyes,name" 
                            value={formData.currentTreatmentDetails} onChange={(e) => handleChange("currentTreatmentDetails", e.target.value)} />
                        <InputBasic Translation="Profiles.MentalHealth.Diagnosis" 
                        value={formData.currentDiagnosis} onChange={(e) => handleChange("currentDiagnosis", e.target.value)} />
                    </>
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Haveyoueverbeen")}
                    value={formData.Haveyoueverbeen} onChange={(value) => handleChange("Haveyoueverbeen", value)} />
                {formData.Haveyoueverbeen === "yes" && (
                    <>
                        <InputBasic Translation="Profiles.MentalHealth.Ifyes,name" 
                            value={formData.HaveyoueverbeenDetails} onChange={(e) => handleChange("HaveyoueverbeenDetails", e.target.value)} />
                        <TableContainer component={Paper}>
                            <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Profiles.MentalHealth.Date")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.WhereHospitalized")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.Reason")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.Duration")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.hospital.map((member, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TextField fullWidth type="date" value={member.Date} onChange={(e) => handleHouseholdChange(index, "Date", e.target.value)} /></TableCell>
                                        <TableCell>
                                            <TextField fullWidth value={member.WhereHospitalized} onChange={(e) => handleHouseholdChange(index, "WhereHospitalized", e.target.value)} /></TableCell>
                                        <TableCell>
                                            <TextField fullWidth value={member.Reason} onChange={(e) => handleHouseholdChange(index, "Reason", e.target.value)} /></TableCell>
                                        <TableCell>
                                            <TextField fullWidth value={member.Duration} onChange={(e) => handleHouseholdChange(index, "Duration", e.target.value)} /></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                            <Button variant="contained" color="primary" sx={{ mt: 2, mr: 1 }} onClick={addHouseholdMember}>{t("Profiles.MentalHealth.AddHospitalization")}</Button>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={removeHouseholdMember} disabled={formData.hospital.length === 1}>{t("Profiles.MentalHealth.DeleteHospitalization")}</Button>
                        </TableContainer>
                    </>
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <InputsYorN translationKey={t("Profiles.MentalHealth.Areyoutakingmedications")}
                    value={formData.Areyoutakingmedications} onChange={(value) => handleChange("Areyoutakingmedications", value)} />
            </Box>
            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepMentalHealthCuestTwo;
